import { Icon } from "@iconify/react/dist/iconify.js";
import { CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Label from "../../../components/Common/Label";
import PopoverFilter2 from "../../../components/Common/PopoverFilter2";
import SearchBar from "../../../components/Common/Searchbar";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import Helpers from "../../../helpers/helpers";
import { getErpDetails } from "../../../store/actions";
import AppDialog from "../../../components/Common/AppDialog";
import { quotationAdvertListingApi } from "../../../store/quotation/quotationApi";
import { advertErpListingApi } from "../../../store/advert/advertApi";

const QuotationVehicleList = ({ formObj, handleFormChange, windowWidth, isEdit, isDirectSeller, isSingPass, makeList, modelList, bodyList, erpDetails, error, setIsLoading, handleVehicleObjChange, onSelect, onPaginationChange }) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [filterObject, setFilterObject] = useState({});
    const [detailOpen, setDetailOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState(9);
    const [advertVehicles, setAdvertVehicles] = useState(null);
    const [inventoryVehicles, setInventoryVehicles] = useState(null);
    const [listingLoading, setListingLoading] = useState(formObj?.advert_type === "listing");
    const [inventoryLoading, setInventoryLoading] = useState(formObj?.advert_type === "inventory");
    const [selectedDetail, setSelectedDetail] = useState(null);
    const searchRef = useRef(search);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        initData();
    }, [page, length, filterObject, formObj?.advert_type]);

    const initData = async () => {
        const selectedId = isEdit
            ? formObj?.advert_type === "listing"
                ? formObj?.vehicle?.bike_advert_id ?? formObj?.vehicle?.id
                : formObj?.vehicle?.erp_id ?? formObj?.vehicle?.id
            : null;
        let payload = {
            page: page,
            length: length,
            search: searchRef.current,
            make: filterObject?.make || '',
            model: filterObject?.model || '',
            body: filterObject?.body_type || '',
            yearFrom: filterObject?.startYear || '',
            yearTo: filterObject?.endYear || '',
            inventoryType: formObj?.advert_type === "listing" ? "new" : '',
            selectedId,
            usage: "quotation"
        }
        if (formObj?.advert_type === "listing") {
            try {
                setListingLoading(true);
                setIsLoading(true);
                const response = await quotationAdvertListingApi(payload);
                setAdvertVehicles(response?.library || null);
            } catch (requestError) {
                setAdvertVehicles({ data: [], last_page: 1 });
            } finally {
                setListingLoading(false);
                setIsLoading(false);
            }
            return;
        }
        try {
            setInventoryLoading(true);
            setIsLoading(true);
            const response = await advertErpListingApi(payload);
            setInventoryVehicles(response?.data || null);
        } catch (requestError) {
            setInventoryVehicles({ data: [], last_page: 1 });
        } finally {
            setInventoryLoading(false);
            setIsLoading(false);
        }
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage(page === 1 ? '1' : 1);
            }
        }, Helpers.searchInterval);
    }


    const filteredModelList = () => {
        if (filterObject?.make) {
            return makeList?.find((item) => filterObject?.make?.includes(item?.id))?.models || modelList;
        }
        return modelList;
    }

    const resetFilter = () => {
        setFilterObject({});
        setPage(page === 1 ? '1' : 1);
    }

    const customToolsBar = () => {
        return (
            <Grid container spacing={2} mt={0} px={2} pt={0}>
                <Grid container item lg={12} md={12} style={{ display: 'flex', alignItems: "center", paddingTop: 0 }} spacing={2}>
                    <Grid item lg={5} md={4} sm={4} xs={12} className="d-flex">
                        <SearchBar
                            value={search}
                            setValue={(e) => handleSearch(e)}
                            module={'make, model, or reg. no'}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={5}>
                        <PopoverFilter2
                            module={'Make'}
                            placeholder={'Make'}
                            paddingInline={"5px"}
                            value={filterObject?.make || []}
                            notShowingModuleTitle={true}
                            filterData={[
                                {
                                    module: 'Make',
                                    list: makeList,
                                    valueName: 'id',
                                    labelName: 'name',
                                }]
                            }
                            setValue={(e) => {
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    make: e
                                }));
                                setPage(page === 1 ? '1' : 1);
                            }}
                        />
                    </Grid>
                    <Grid item lg={2} md={3} sm={3} xs={5}>
                        <PopoverFilter2
                            module={'Model'}
                            placeholder={'Model'}
                            paddingInline={"5px"}
                            value={filterObject?.model || []}
                            notShowingModuleTitle={true}
                            filterData={[
                                {
                                    module: 'Model',
                                    list: filteredModelList(),
                                    valueName: 'id',
                                    labelName: 'name',
                                }]
                            }
                            setValue={(e) => {
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    model: e
                                }));
                                setPage(page === 1 ? '1' : 1);
                            }}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={2}
                        sm={2}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <CustomButton
                            title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                        />
                    </Grid>
                </Grid>

            </Grid>
        )
    }

    const renderVehicleList = (item, idx) => {
        const sourceIdKey = formObj?.advert_type === "listing" ? "bike_advert_id" : "erp_id";
        const selectedVehicleId = formObj?.vehicle?.[sourceIdKey] ?? formObj?.vehicle?.id;
        const itemVehicleId = item?.[sourceIdKey] ?? item?.id;
        const isSelected = selectedVehicleId !== null && selectedVehicleId !== undefined
            && String(selectedVehicleId) === String(itemVehicleId);

        return (
            <Grid item lg={4} md={12} sm={12} xs={12} key={`vehicle-${idx}`}>
                <div className="dashboard-card p-3">
                    <div className="text-semibold font-size-16 d-flex">{item?.make || '-'} {item?.model || ''} <Label.GeneralStatusLabel label={item?.status} list={Helpers.advertStatus} marginLeft={"5px"}/></div>
                    <div className="d-flex align-items-center mt-2">
                        {
                            Boolean(item?.manu_year) &&
                            <Label.CustomLabel
                                label={item?.manu_year}
                                color={'#808588'}
                                backgroundColor={'#F5F5F5'}
                                border={"1px solid #F5F5F5"}
                                borderRadius={6}
                            />
                        }
                        {
                            (Boolean(item?.engine_cc) || Boolean(item?.engine_cap)) &&
                            <Label.CustomLabel
                                label={item?.engine_cc || item?.engine_cap}
                                color={'#808588'}
                                backgroundColor={'#F5F5F5'}
                                border={"1px solid #F5F5F5"}
                                borderRadius={6}
                                marginLeft={Boolean(item?.manu_year) ? 10 : 0}
                            />
                        }
                    </div>
                    <div className="my-3 mb-4">
                        <div className="subheader-3">Reg No.</div>
                        <div>{item?.reg_no || item?.register_number || '-'}</div>
                        {!isSingPass ?
                            <>
                                <div className="subheader-3 mt-1">Stock ID</div>
                                <div>{item?.stock_id || '-'}</div>
                                <div className="subheader-3 mt-1">Body Type</div>
                                <div>{item?.body_type || '-'}</div>
                            </> :
                            <>
                                <div className="subheader-3 mt-1">COE Expiry Date</div>
                                <div>{item?.coe_expiry || '-'}</div>
                                <div className="subheader-3 mt-1">No. of Owner(s)</div>
                                <div>{item?.no_of_owner || '-'}</div>
                            </>
                        }

                    </div>
                    <div className="mb-3">
                        <CustomButton
                            title={isSelected ? 'Selected' : 'Select This Unit'}
                            press={() => {
                                handleFormChange('vehicle', item);
                                onSelect?.(item);
                            }}
                            width={'100%'}
                            backgroundColor={isSelected ? '#1D1B1B' : '#F5F5F5'}
                            textColor={isSelected ? '#FFFFFF' : '#1D1B1B'}
                            padding={20}
                        />
                    </div>
                    <div>
                        <CustomButton
                            title={<div className="d-flex align-items-center">View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>}
                            press={() => {
                                if (formObj?.advert_type === "listing") {
                                    setSelectedDetail(item);
                                } else {
                                    dispatch(getErpDetails({ id: item?.id }));
                                    setIsLoading(true);
                                }
                                setDetailOpen(true);
                            }}
                            width={'100%'}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                            padding={20}
                        />
                    </div>
                </div>
            </Grid>
        )
    }

    const detailVehicle = formObj?.advert_type === "listing" ? selectedDetail : erpDetails;
    const vehicleLoading = formObj?.advert_type === "listing" ? listingLoading : inventoryLoading;
    const vehicleOptions = formObj?.advert_type === "listing" ? advertVehicles : inventoryVehicles;
    const totalPage = vehicleOptions?.last_page || 1;

    useEffect(() => {
        if (!onPaginationChange) return undefined;

        onPaginationChange({
            length,
            setLength,
            page,
            setPage,
            totalPage,
            loading: vehicleLoading,
        });

        return () => onPaginationChange(null);
    }, [length, page, totalPage, vehicleLoading, onPaginationChange]);

    return (
        <React.Fragment>
            <Grid container spacing={2} mt={isEdit ? "5px" : "auto"}>
                <Grid
                    item
                    xs={12}
                    sx={{
                        position: isEdit ? 'static' : 'sticky',
                        top: isEdit ? 'auto' : 0,
                        zIndex: isEdit ? 'auto' : 5,
                        backgroundColor: '#FFFFFF',
                        borderBottom: '1px solid #F0F0F0',
                        pb: 2,
                        pt: 0,
                        mt: 0
                    }}
                >
                    {customToolsBar()}
                </Grid>

                {/* <Grid item container lg={12} md={12} sm={12} spacing={2} mt={0}> */}
                {
                    vehicleLoading
                        ? <Grid item sm={12} xs={12} className="d-flex align-items-center justify-content-center" style={{ color: '#808588', minHeight: 200, gap: 1 }}>
                            <CircularProgress size={24} color="inherit" />
                            <span>{formObj?.advert_type === "listing" ? "Loading listings..." : "Loading inventory..."}</span>
                        </Grid>
                        : vehicleOptions?.data?.length > 0 ?
                            vehicleOptions.data.map((item, idx) => renderVehicleList(item, idx))
                            : <Grid item sm={12} xs={12} className="d-flex align-items-center justify-content-center" style={{ color: '#999999', minHeight: 200 }}>Nothing here yet</Grid>
                }
                {/* </Grid> */}
                {isEdit && !vehicleLoading && <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    mt={2}
                    className="d-flex justify-content-center"
                    sx={{
                        position: 'static',
                        backgroundColor: '#FFFFFF',
                        borderTop: '1px solid #F0F0F0',
                    }}
                    style={{ textAlign: 'center' }}
                >
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={totalPage}
                        justifyContent="center"
                    />
                </Grid>}
            </Grid>
            <AppDialog
                open={detailOpen}
                close={() => setDetailOpen(false)}
                vehicleData={detailVehicle}
                title={`${detailVehicle?.make || ""} ${detailVehicle?.model || ""} ${detailVehicle?.manu_year ? `(${detailVehicle?.manu_year})` : ''}`}
                positiveTitle={'Close'}
                positivePress={() => setDetailOpen(false)}
                width={'60%'}
                isMobile={windowWidth <= 768 ? true : false}
            >
                <Grid container spacing={2}>
                    <Grid item lg={6} md={5} sm={12} xs={12} className="subheader-3">Make / Model</Grid>
                    <Grid item lg={6} md={7} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.make} / {detailVehicle?.model}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Number</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.reg_no || detailVehicle?.register_number || '-'}
                    </Grid>

                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock ID</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.stock_id || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Body Type</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.body_type || '-'}
                    </Grid>

                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Primary Colour</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.primary_colour || detailVehicle?.color || detailVehicle?.colour || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Year of Manufacture</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.manu_year || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Category</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.coe_category || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Internal Remarks</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {detailVehicle?.internal_remarks || '-'}
                    </Grid>
                </Grid>
            </AppDialog>
        </React.Fragment>
    )
}


function mapStateToProps({ Advert, General, Layout }) {
    return {
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        erpDetails: Advert.erpDetails?.data || null,
        windowWidth: Layout.currentWidth,
    };
}


export default connect(mapStateToProps)(QuotationVehicleList);
